/**
 * @Author: Nenad Brcic
 * @Date: 28.05.16
 * @Email: neno@neno.ch
 */

import React from 'react';
import ObjectEntry from '../Object/Entry';
import NoRecordsFound from '../shared/NoRecordsFound';
import CSSModules from 'react-css-modules';
import styles from './search-results.scss';

const Objects = (props) => {

    let objects = [];
    if( !!props.objects && props.objects.edges.length ) {
        objects = props.objects.edges.map(edge => {
            return <ObjectEntry key={ edge.node.id } object={ edge.node } />;
        });
    }

    return (
        <section >
            <h2 styleName="section-title">
                            <span styleName="section-title-inner">
                                { props.title }
                            </span>
            </h2>
            <ul className="object-list">
                { objects.length ? objects : <NoRecordsFound lang={ props.lang } /> }
            </ul>
        </section>
    )
};

export default CSSModules(Objects, styles);


// WEBPACK FOOTER //
// ./app/components/SearchResults/Objects.jsx